import { getUserAccountData, loginUser, getMangopayUserData } from '@/helpers/externals/user'
// import router from '@/router'
import store from '@/store/index'
import axios from 'axios'

const state = {
  isAuthenticated: false,
  selectedUserAccess: 'twip_employee', // null
  userData: {},
  csrf: null,
  mangopayUserData: null,
  status: '' // to be removed
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  isFrauder: state => state.userData.isFrauder,
  hasCorporation: state => state.userData.corporationId,
  shouldCheckMobilePhone: state => state.userData.shouldCheckMobilePhone,
  authStatus: state => state.status,
  selectedUserAccess: state => state.selectedUserAccess,
  userPhone: state => state.userData.mobilePhone,
  userData: state => state.userData,
  mangopayUserData: state => state.mangopayUserData,
  isBookingAllowed: state => true, // state.selectedUserAccess === 'twip_employee' || state.selectedUserAccess === 'twip_fleet'
  isTopUpWalletAllowed: state => true, // state.selectedUserAccess === 'twip_employee'
  csrf: state => state.csrf
}

const mutations = {
  authError: (state) => {
    state.authStatus = 'error'
  },
  authLogin: (state) => {
    state.isAuthenticated = true
  },
  setCsrf: (state) => {
    // retrieve csrf and set axios header
    const csrf = getCookie('csrftoken')
    axios.defaults.headers['X-CSRFToken'] = csrf
    state.csrf = csrf
  },
  authLogout: state => {
    state.isAuthenticated = false
    state.userData = {}
  },
  setUserData(state, payload) {
    state.userData = {
      userId: payload.user_id,
      firstName: payload.first_name,
      lastName: payload.last_name,
      mobilePhone: payload.mobile_phone,
      shouldCheckMobilePhone: payload.should_check_mobile_phone,
      dateJoined: payload.date_joined,
      email: payload.email,
      payline: payload.payline_user,
      prepaidAccount: {
        prepaidAccountId: payload.prepaid_accounts[0].pk,
        credits: payload.prepaid_accounts[0].fields.credits
      },
      isFrauder: payload.is_frauder,
      corporationId: payload.corporation
    }
  },
  setMangopayUserData(state, payload) {
    state.mangopayUserData = payload
  },
}

function getCookie(name) {
  let cookieValue = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
}

const actions = {
  async authLogin({ dispatch, commit }, data) {
    // login user
    await loginUser(data)

    // if the login was sucessfully completed
    // we should have the cookie, then getUserData will call the /me
    // to get the user data and set the app in au
    await dispatch('getUserData')

    // add CSRF by default on axios header
    commit('setCsrf')

    // get vehicles/booking informations
    dispatch('Vehicles/getVehicles', null, { root: true })
    dispatch('Bookings/getBookings', null, { root: true })
  },

  async getUserData({ commit, dispatch }) {
    await getUserAccountData()
    await getMangopayUserData()
  },


  async tryAutoLogin({ commit, dispatch }) {
    // try to get the user data
    await dispatch('getUserData')

    // if getUserData was successful, the isAuthenticated must be true
    if (store.getters['Auth/isAuthenticated']) {
      // add CSRF by default on axios header
      commit('setCsrf')

      dispatch('Vehicles/getVehicles', null, { root: true })
      // dispatch('Bookings/getBookings', null, { root: true })
      dispatch('SimpleBookings/getBookings', null, { root: true })
    }
  },


  authLogout: async ({ commit, dispatch }) => {
    // await logoutUser()
    commit('authLogout')
    commit('Vehicles/clearVehicles', null, { root: true })
    commit('Cart/clearCart', null, { root: true })
    delete axios.defaults.headers.common['X-CSRFToken'] // remove the Auth Header
    // let django perform the logout
    window.location.href = '/logout/'
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
